module.exports = __webpack_public_path__ + "img/infinity-war.1d5fa12.jpg";